var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 123,
    viewBox: "0 0 124 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7917,
    cy: 61.0417,
    r: 51.0417,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_58149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9987 10.2085C33.8237 10.2085 10.957 33.0752 10.957 61.2502C10.957 89.4252 33.8237 112.292 61.9987 112.292C90.1737 112.292 113.04 89.4252 113.04 61.2502C113.04 33.0752 90.1737 10.2085 61.9987 10.2085ZM48.1664 83.147L29.8424 64.8231C27.8518 62.8325 27.8518 59.6168 29.8424 57.6262C31.8331 55.6356 35.0487 55.6356 37.0393 57.6262L51.7904 72.3262L86.907 37.2095C88.8977 35.2189 92.1133 35.2189 94.1039 37.2095C96.0945 39.2002 96.0945 42.4158 94.1039 44.4064L55.3633 83.147C53.4237 85.1377 50.157 85.1377 48.1664 83.147Z",
    fill: "#1BB718"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_58149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.5,
    height: 122.5,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreen);
export default __webpack_public_path__ + "static/media/success_green.453918e84f497bb2fc967cd902c7ac45.svg";
export { ForwardRef as ReactComponent };